import './Footer.css';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import Title2Footer from '../styled-components/Title2Footer';
import Paragraph from '../styled-components/Paragraph';
import {
  cedocLocationAdm,
  cedocLocationArm,
  comercialEmail,
  geralTel2,
} from './Links';

function Footer() {
  const [inProp, setInProp] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setInProp(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="Footer">
      <CSSTransition in={inProp} timeout={500} classNames="fade" unmountOnExit>
        <footer>
          <div id="footer-content">
            <section className="footer-sec">
              <Title2Footer>Contato</Title2Footer>
              <ul>
                <li><span>📧</span><a href={comercialEmail}>comercial@cedoc.net.br</a></li>
                <li><span>📞</span><a href={geralTel2}>(31) 99990-0722</a></li>
              </ul>
            </section>

            <section className="footer-sec">
              <Title2Footer>Localização</Title2Footer>
              <ul>
                <li><span>📍</span><p>Unidade Administrativa</p>
                  <a href={cedocLocationAdm}>Avenida Portugal, 399 – Jardim Atlântico – Belo Horizonte – MG</a>
                </li>
                <li><span>🏢</span><p>Unidade de Armazenamento</p>
                  <a href={cedocLocationArm}>Rua Alcobaça, 831 – São Francisco – Belo Horizonte – MG</a>
                </li>
              </ul>
            </section>

            <section className="footer-sec">
              <Title2Footer>Páginas</Title2Footer>
              <ul>
                <li><Link to="/services">Serviços e Soluções</Link></li>
                <li><Link to="/clients">Clientes</Link></li>
                <li><Link to="/about">Sobre nós</Link></li>
              </ul>
            </section>
          </div>

          <div id="copyright">
            <Paragraph>© cedoc.net.br – Todos os direitos reservados.</Paragraph>
            <Paragraph>Direção <strong>Roosevelt Mello Passos</strong></Paragraph>
          </div>
        </footer>
      </CSSTransition>
    </div>
  );
}

export default Footer;
